<template>
	<div class="container ">
		<div class="left-img">
			<img src="@/assets/images/down-big-img.png" alt="" />
			<!-- <el-image src='@/assets/images/down-big-img.png' lazy></el-image> -->
		</div>
		<div class="right-info">
			<div class="info1">
				<img src="@/assets/images/info-photo.png" alt="" />
			</div>
			<div class="info2">
				 营养人正在使用的学习神器：
			</div>
			<div class="info3">
				 1、完整体验课程播放、笔记、提问等功能<br>
				 2、包含题库、背诵、答疑、考试等多个学习模块<br>
				 3、制定学习目标，学习数据全记录
			</div>
			<div class="info4 fl-al">
				<div class="sao-ma">
					<!-- <img src="../../assets/images/down-code.png" alt="" /> -->
					<img :src="middlePageQrCode" alt="" />
				</div>
				<div class="ma-word">
					<div class="txt1">
						用手机扫描二维码下载
					</div>
					<!-- <div class="fl-al">
						或 <div class="to-down txt-act fl-al">用手机扫描二维码下载
						<img src="@/assets/icons/orange-more.png" alt="" /></div>
					</div> -->
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	import { userInfoApi } from '@/api/user/user';
	export default {
		data() {
			return {
				middlePageQrCode:''
			}
		},
		mounted() {
		    // 在 mounted 钩子中动态添加样式
		    // document.body.style.backgroundColor = '#631';
			userInfoApi().then(res=>{
				console.log(res);
				this.middlePageQrCode = res.data.middlePageQrCode
			})
		},
		beforeDestroy() {
		},
	}
</script>

<style lang="scss" scoped>
	// body::-webkit-scrollbar {
	//   display: block; /* 预留滚动条的空间 */
	//   position: absolute;
	//   right: 0;
	//   top: 0;
	//   bottom: 0;
	//   width: 17px; /* 滚动条宽度，根据实际情况调整 */
	//   background: transparent; /* 或者与容器背景色相同的颜色 
	//   opacity: 0; /* 如果需要，可以设置透明度 */
	// }
	// body{
	// 	overflow-y: scroll;
	// }
	.container{
		width: 1200px;
		// max-width: 1860px;
		height: 660px;
		margin: 0 auto;
		overflow: hidden;
		display: flex;
	}
	.left-img{
		margin-top: 205px;
		width: 699px;
		height:344px;
		img{
			width: 699px;
			height:344px;
		}
	}
	.right-info{
		margin-left: 126px;
		margin-top: 104px;
		.info1{
			img{
				width: 292px;
				height: 60px;
			}
		}
		.info2{
			margin-top: 47px;
			font-weight: 500;
			font-size: 20px;
			color: #333333;
		}
		.info3{
			color: #636262;
			margin-top: 24px;
		}
		.info4{
			margin-top: 121px;
			img{
				width: 116px;
				height: 116px;
			}
			.ma-word{
				margin-left: 20px;
				color: #333333;
				.txt1{
					margin-bottom: 12px;
				}
				.to-down{
					color: #FF8B02;
					margin-left: 8px;
					img{
						width: 16px;
						height: 16px;
						margin-left: 4px;
					}
				}
			}
		}
	}
</style>